import { trimTextField, formattedToNumber, } from '@/utils';
import { CAR_NUMBER_PATTERN } from '@/utils/regularExpression';
import { computed } from 'vue';
import { validationLimitingValue } from '@/constants';
import { i18n } from '@/locales';
import { isRequired, greaterThanMinLength, isValidPattern, isSameAsLimitLength, lessThanMaxAmount, } from './index';
const { PHONE_MIN_LENGTH, HYPEN_SOCIAL_NUMBER_LIMIT_LENGTH, LICENSE_NUMBER_MIN_LENGTH, MIN_FINISH_MINUTE_AFTER_ALLOCATED_MAX_AMOUNT, } = validationLimitingValue;
const createWorkerFormRules = (lc) => ({
    name: computed({
        get() {
            return [
                (v) => isRequired(trimTextField(v))
                    || i18n.t(`${lc}value_require`),
            ];
        },
        set() { },
    }),
    phone: computed({
        get() {
            return [
                (v) => isRequired(v)
                    || i18n.t(`${lc}value_require`),
                (v) => greaterThanMinLength(v.length, PHONE_MIN_LENGTH)
                    || i18n.t(`${lc}greater_than_min_length`, {
                        length: PHONE_MIN_LENGTH,
                    }),
            ];
        },
        set() { },
    }),
    telNumber: computed({
        get() {
            return [
                (v) => !isRequired(v)
                    || greaterThanMinLength(v.length, PHONE_MIN_LENGTH)
                    || i18n.t(`${lc}greater_than_min_length`, {
                        length: PHONE_MIN_LENGTH,
                    }),
            ];
        },
        set() { },
    }),
    hubEmployeeNumber: computed({
        get() {
            return [
                (v) => isRequired(trimTextField(v))
                    || i18n.t(`${lc}value_require`),
            ];
        },
        set() { },
    }),
    type: computed({
        get() {
            return [
                (v) => isRequired(trimTextField(v))
                    || i18n.t(`${lc}value_require`),
            ];
        },
        set() { },
    }),
    // 입사일
    workerRegDate: computed({
        get() {
            return [
                (v) => isRequired(trimTextField(v))
                    || i18n.t(`${lc}value_require`),
            ];
        },
        set() { },
    }),
    socialNumber: computed({
        get() {
            return [
                (v) => !isRequired(v)
                    || isSameAsLimitLength(v.length, HYPEN_SOCIAL_NUMBER_LIMIT_LENGTH)
                    || i18n.t(`${lc}wrong_value`, {
                        field: '주민등록번호',
                    }),
            ];
        },
        set() { },
    }),
    licenseNumber: computed({
        get() {
            return [
                (v) => !isRequired(v)
                    || greaterThanMinLength(v.length, LICENSE_NUMBER_MIN_LENGTH)
                    || i18n.t(`${lc}greater_than_min_length`, {
                        length: LICENSE_NUMBER_MIN_LENGTH,
                    }),
            ];
        },
        set() { },
    }),
    carNumber: computed({
        get() {
            return [
                (v) => !isRequired(v)
                    || isValidPattern(CAR_NUMBER_PATTERN, v)
                    || i18n.t(`${lc}wrong_value`, {
                        field: '차량번호',
                    }),
            ];
        },
        set() { },
    }),
    minFinishMinuteAfterAllocated: computed({
        get() {
            return [
                (v) => lessThanMaxAmount(formattedToNumber(v), MIN_FINISH_MINUTE_AFTER_ALLOCATED_MAX_AMOUNT)
                    || i18n.t(`${lc}available_max_amount_to_enter`, {
                        max: '15',
                    }),
            ];
        },
        set() { },
    }),
});
export default createWorkerFormRules;
